import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';
import { first } from 'rxjs/operators';

const SIDEBAR_STATE_STORAGE_TOKEN = 'SIDEBAR_STATE';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  constructor(private storageService: StorageService) {}

  private isSidebarOpen = new BehaviorSubject<boolean>(
    this.getSidebarStateFromStorage()
  );
  public isSidebarOpen$ = this.isSidebarOpen.asObservable();

  public open() {
    this.setSidebarState(true);
  }

  public close() {
    this.setSidebarState(false);
  }

  public toggle() {
    this.isSidebarOpen$.pipe(first()).subscribe((oldState) => {
      this.setSidebarState(!oldState);
    });
  }

  private setSidebarState(state: boolean) {
    this.isSidebarOpen.next(state);
    this.storageService.setLocalStorageItem(SIDEBAR_STATE_STORAGE_TOKEN, state);
  }

  private getSidebarStateFromStorage(): boolean {
    const sideBarState = this.storageService.getLocalStorageItem(
      SIDEBAR_STATE_STORAGE_TOKEN
    );
    return sideBarState == 'true';
  }
}
